// extracted by mini-css-extract-plugin
export default {"ResponsiveContainerRefSkin":"S6Dcte","responsiveContainerRefSkin":"S6Dcte"};